import React, { useEffect, useState } from 'react'
import CommonPopupForm from './CommonPopupForm';
import { getProducts, createDepartment, fetchDepartments, deleteDepartment, updateDepartments } from '../../../services/customOffers'
import {fetchMedicalDepartments} from '../../../services'
function Departments() {
    const [isOpen, setIsOpen] = useState(false);
    const [img, setImg] = useState(null);
    const [formData, setFormData] = useState({
        image: null,
        product: "",
        title: "",
        stock_no: "",
        group_no: "",
        key_points: [],

    });
    const [productId, setProductId] = useState([]);
    const [search, setSearch] = useState("");
    const [searchMedDep, setSearchMedDep] = useState("");
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [isMedOpen, setIsMedOpen] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [medicalDepartments, setMedicalDepartments] = useState([]);
    const [editingId, setEditingId] = useState(null);

    const filteredOptions = productId.filter((item) =>
        item.equip_name.toLowerCase().includes(search.toLowerCase())
    );

    const filterMedicalDepartment = medicalDepartments?.filter((item)=>
    item.name.toLowerCase().includes(searchMedDep.toLowerCase()))
    // Get unique titles from departments to avoid repetition
    const titleName = Array.from(new Set(departments.map((item) => item.title)));
    // const titleName = Array.from(new Set(medicalDepartments.map((item) => item.name)));

    const fetchProducts = async () => {
        try {
            const res = await getProducts();
            // console.log(res?.data?.data?.results)
            setProductId(res?.data?.data?.results)
        } catch (error) {
            console.error(error)
        }
    };
    const getDepartments = async () => {
        try {
            const res = await fetchDepartments();
            // console.log(res?.data?.data);
            setDepartments(res?.data?.data);


        } catch (error) {
            console.error(error)
        }
    };
  const getMedicalDepartments = async () => {
      try {
        const res = await fetchMedicalDepartments();
        // console.log(res?.data?.data)
        setMedicalDepartments(res?.data?.data)
      } catch (error) {
        console.error(error);
      }
    }
    useEffect(() => {
        fetchProducts();
        getDepartments();
        getMedicalDepartments();
    }, []);
    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleImage = (e) => {
        const file = e.target.files[0]; // Corrected this line
        if (file) {
            setImg(file);
            setFormData({ ...formData, image: file }); // Update formData.image as well
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataToSend = new FormData();
            const keyPointsArray = formData.key_points
                .split(',')
                .map(item => item.trim())
                .filter(item => item !== '');

            formDataToSend.append('key_points', JSON.stringify(keyPointsArray));
            formDataToSend.append('title', formData.title);
            formDataToSend.append('stock_no', formData.stock_no);
            formDataToSend.append('group_no', formData.group_no);
            formDataToSend.append('product', formData.product);


            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            let res;
            if (editingId) {
                res = await updateDepartments(editingId, formDataToSend);

            } else {
                res = await createDepartment(formDataToSend);
            }

            if (res) {
                getDepartments()
                setIsOpen(false);
                setImg(null)
                setFormData(
                    {
                        image: null,
                        title: "",
                        stock_no: "",
                        group_no: "",
                        key_points: [],
                        product: ""

                    }
                )
            }
        } catch (error) {
            console.error(error)
        }
    };

    const handleEdit = (item) => {
        setEditingId(item.uid); // store the ID for editing
        // console.log("lls",item.product_detail.uid)
        setImg(item.image); // optional: image preview
        setFormData({
            image: null,
            title: item.title || "",
            stock_no: item.stock_no || "",
            group_no: item.group_no || "",
            product: item.product || "",
            key_points: Array.isArray(item.key_points) ? item.key_points.join(', ') : "",

        });
        setIsOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            const res = await deleteDepartment(id);
            if (res) {
                getDepartments()
            }
        } catch (error) {
            console.error(error)
        }
    };
    // console.log("title", productId)
    return (
        <div>
            <div className='flex items-center justify-between my-6'>
                <h1 className='font-bold text-3xl'>Choose By Departments</h1>
                <button
                    className="bg-[#019c89] text-white px-4 py-2 rounded"
                    onClick={() => setIsOpen(true)}
                >
                    Add 
                </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {departments?.map((item, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-3xl shadow-lg border border-gray-200 hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-[1.02] flex flex-col"
                    >
                        {/* <img
                            src={item.image}
                            alt="Promotion"
                            className="w-full h-48 object-cover rounded-t-3xl"
                        /> */}

                        {/* Card Body */}
                        <div className="p-5 flex flex-col justify-between flex-1">
                            {/* Top Content */}
                            <div>
                                <h2 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
                                    {item.title}
                                </h2>


                                <div className="flex justify-between text-sm mb-3">
                                    <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">
                                        Stock No. : {item.stock_no}
                                    </span>
                                    <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full">
                                        Group No. : {item.group_no}
                                    </span>
                                </div>

                                <p className="text-gray-600 text-sm mb-3 line-clamp-3">{item.description}</p>

                                <div className="mb-4">
                                    <p className="text-sm font-semibold text-gray-700 mb-1">Key Points:</p>
                                    <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 max-h-[100px] overflow-y-auto scrollbar-thin scrollbar-thumb-blue-300 pr-1">
                                        {item?.key_points?.map((point, idx) => (
                                            <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end space-x-2 pt-4 mt-auto">
                                <button
                                    onClick={() => handleEdit(item)}
                                    className="px-4 py-2 text-sm text-white bg-gradient-to-r from-blue-500 to-blue-700 rounded-full hover:from-blue-600 hover:to-blue-800 transition"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(item.uid)}
                                    className="px-4 py-2 text-sm text-white bg-gradient-to-r from-red-500 to-red-700 rounded-full hover:from-red-600 hover:to-red-800 transition"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <CommonPopupForm
                title="Add Choose By Departments"
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                    setEditingId(null);
                    setImg(null);
                    setFormData({
                        image: null,
                        title: "",
                        stock_no: "",
                        group_no: "",
                        key_points: [],
                        product: ""
                    });
                }
                }
                onSubmit={handleSubmit}
            >
                {/* Image Upload */}
                {/* <div className="p-4 space-y-2">
                    <label className="block text-sm font-medium text-gray-700"> Image</label>
                    <input
                        type="file"
                        name="image"
                        onChange={handleImage}
                        accept="image/*"
                        className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                    />
                    {img && (
                        <img
                            src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                            alt="Preview"
                            className="w-32 h-32 object-cover mt-2 rounded border"
                        />
                    )}
                </div> */}

                {/* Form Fields */}
                <div className="grid lg:grid-cols-2 gap-8 p-4">

                    <div className="space-y-2 relative">
                        <label className="block text-sm font-medium text-gray-700">Product</label>
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setIsSelectOpen(true);
                            }}
                            onFocus={() => setIsSelectOpen(true)}
                            placeholder="Search product"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                        {isSelectOpen && (
                            <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-auto">
                                {filteredOptions.length > 0 ? (
                                    filteredOptions.map((item) => (
                                        <li
                                            key={item.uid}
                                            onClick={() => {
                                                setSearch(item.equip_name);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    product: item.uid                 // Set actual UID to send
                                                }));
                                                setIsSelectOpen(false);
                                                // update stock_no or any other field
                                            }}
                                            className="px-4 py-2 cursor-pointer hover:bg-[#019c89] hover:text-white text-sm"
                                        >
                                            {item.equip_name}
                                        </li>
                                    ))
                                ) : (
                                    <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                                )}
                            </ul>
                        )}
                    </div>
                     <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">{titleName.length > 0 ? 'New Title' : 'Title'}</label>
                           <input
                            type="text"
                            value={searchMedDep}
                            onChange={(e) => {
                                setSearchMedDep(e.target.value);
                                setIsMedOpen(true);
                            }}
                            onFocus={() => setIsMedOpen(true)}
                            placeholder="Search product"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                        {isMedOpen && (
                            <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-auto">
                                {filterMedicalDepartment.length > 0 ? (
                                    filterMedicalDepartment.map((item) => (
                                        <li
                                            key={item.uid}
                                            onClick={() => {
                                                setSearchMedDep(item.name);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    title: item.name         
                                                }));
                                                setIsMedOpen(false);
                                                // update stock_no or any other field
                                            }}
                                            className="px-4 py-2 cursor-pointer hover:bg-[#019c89] hover:text-white text-sm"
                                        >
                                            {item.name}
                                        </li>
                                    ))
                                ) : (
                                    <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                                )}
                            </ul>
                        )}
                    </div>

                    {titleName.length > 0 && (
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Add in title</label>
                            <select
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            >
                                <option value="">Select a title</option>
                                {titleName.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Stock Number</label>
                        <input
                            type="text"
                            name="stock_no"
                            value={formData.stock_no}
                            onChange={handleChange}
                            placeholder="Enter stock number"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Key Points</label>
                        <input
                            type="text"
                            name="key_points"
                            value={formData.key_points}
                            onChange={handleChange}
                            placeholder="Enter key points"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Group Number</label>
                        <select
                            name="group_no"
                            value={formData.group_no}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        >
                            <option value="" disabled>Select group number</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>

                        </select>
                    </div>
                </div>
            </CommonPopupForm>



        </div>
    )

}

export default Departments
// import React, { useEffect, useState } from 'react'
// import CommonPopupForm from './CommonPopupForm';
// import { getProducts, createDepartment, fetchDepartments, deleteDepartment, updateDepartments } from '../../../services/customOffers'
// function Departments() {
//     const [isOpen, setIsOpen] = useState(false);
//     const [img, setImg] = useState(null);
//     const [formData, setFormData] = useState({
//         image: null,
//         product: "",
//         title: "",
//         stock_no: "",
//         group_no: "",
//         key_points: [],

//     });
//     const [productId, setProductId] = useState([]);
//     const [search, setSearch] = useState("");
//     const [isSelectOpen, setIsSelectOpen] = useState(false);
//     const [departments, setDepartments] = useState([]);
//     const [editingId, setEditingId] = useState(null);

//     const filteredOptions = productId.filter((item) =>
//         item.equip_name.toLowerCase().includes(search.toLowerCase())
//     );

//     // Get unique titles from departments to avoid repetition
//     const titleName = Array.from(new Set(departments.map((item) => item.title)));

//     const fetchProducts = async () => {
//         try {
//             const res = await getProducts();
//             // console.log(res?.data?.data?.results)
//             setProductId(res?.data?.data?.results)
//         } catch (error) {
//             console.error(error)
//         }
//     };
//     const getDepartments = async () => {
//         try {
//             const res = await fetchDepartments();
//             // console.log(res?.data?.data);
//             setDepartments(res?.data?.data);


//         } catch (error) {
//             console.error(error)
//         }
//     };
//     useEffect(() => {
//         fetchProducts();
//         getDepartments()
//     }, []);
//     const handleChange = (e) => {
//         const { value, name } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleImage = (e) => {
//         const file = e.target.files[0]; // Corrected this line
//         if (file) {
//             setImg(file);
//             setFormData({ ...formData, image: file }); // Update formData.image as well
//         }
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const formDataToSend = new FormData();
//             const keyPointsArray = formData.key_points
//                 .split(',')
//                 .map(item => item.trim())
//                 .filter(item => item !== '');

//             formDataToSend.append('key_points', JSON.stringify(keyPointsArray));
//             formDataToSend.append('title', formData.title);
//             formDataToSend.append('stock_no', formData.stock_no);
//             formDataToSend.append('group_no', formData.group_no);
//             formDataToSend.append('product', formData.product);


//             if (formData.image) {
//                 formDataToSend.append('image', formData.image);
//             }

//             let res;
//             if (editingId) {
//                 res = await updateDepartments(editingId, formDataToSend);

//             } else {
//                 res = await createDepartment(formDataToSend);
//             }

//             if (res) {
//                 getDepartments()
//                 setIsOpen(false);
//                 setImg(null)
//                 setFormData(
//                     {
//                         image: null,
//                         title: "",
//                         stock_no: "",
//                         group_no: "",
//                         key_points: [],
//                         product: ""

//                     }
//                 )
//             }
//         } catch (error) {
//             console.error(error)
//         }
//     };

//     const handleEdit = (item) => {
//         setEditingId(item.uid); // store the ID for editing
//         // console.log("lls",item.product_detail.uid)
//         setImg(item.image); // optional: image preview
//         setFormData({
//             image: null,
//             title: item.title || "",
//             stock_no: item.stock_no || "",
//             group_no: item.group_no || "",
//             product: item.product || "",
//             key_points: Array.isArray(item.key_points) ? item.key_points.join(', ') : "",

//         });
//         setIsOpen(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             const res = await deleteDepartment(id);
//             if (res) {
//                 getDepartments()
//             }
//         } catch (error) {
//             console.error(error)
//         }
//     };
//     // console.log("title", titleName)
//     return (
//         <div>
//             <div className='flex items-center justify-between my-6'>
//                 <h1 className='font-bold text-3xl'>Choose By Departments</h1>
//                 <button
//                     className="bg-[#019c89] text-white px-4 py-2 rounded"
//                     onClick={() => setIsOpen(true)}
//                 >
//                     Add 
//                 </button>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//                 {departments?.map((item, index) => (
//                     <div
//                         key={index}
//                         className="bg-white rounded-3xl shadow-lg border border-gray-200 hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-[1.02] flex flex-col"
//                     >
//                         <img
//                             src={item.image}
//                             alt="Promotion"
//                             className="w-full h-48 object-cover rounded-t-3xl"
//                         />

//                         {/* Card Body */}
//                         <div className="p-5 flex flex-col justify-between flex-1">
//                             {/* Top Content */}
//                             <div>
//                                 <h2 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
//                                     {item.title}
//                                 </h2>


//                                 <div className="flex justify-between text-sm mb-3">
//                                     <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">
//                                         Stock No. : {item.stock_no}
//                                     </span>
//                                     <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full">
//                                         Group No. : {item.group_no}
//                                     </span>
//                                 </div>

//                                 <p className="text-gray-600 text-sm mb-3 line-clamp-3">{item.description}</p>

//                                 <div className="mb-4">
//                                     <p className="text-sm font-semibold text-gray-700 mb-1">Key Points:</p>
//                                     <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 max-h-[100px] overflow-y-auto scrollbar-thin scrollbar-thumb-blue-300 pr-1">
//                                         {item?.key_points?.map((point, idx) => (
//                                             <li key={idx}>{point}</li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             </div>

//                             {/* Buttons */}
//                             <div className="flex justify-end space-x-2 pt-4 mt-auto">
//                                 <button
//                                     onClick={() => handleEdit(item)}
//                                     className="px-4 py-2 text-sm text-white bg-gradient-to-r from-blue-500 to-blue-700 rounded-full hover:from-blue-600 hover:to-blue-800 transition"
//                                 >
//                                     Edit
//                                 </button>
//                                 <button
//                                     onClick={() => handleDelete(item.uid)}
//                                     className="px-4 py-2 text-sm text-white bg-gradient-to-r from-red-500 to-red-700 rounded-full hover:from-red-600 hover:to-red-800 transition"
//                                 >
//                                     Delete
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <CommonPopupForm
//                 title="Add Choose By Departments"
//                 isOpen={isOpen}
//                 onClose={() => {
//                     setIsOpen(false);
//                     setEditingId(null);
//                     setImg(null);
//                     setFormData({
//                         image: null,
//                         title: "",
//                         stock_no: "",
//                         group_no: "",
//                         key_points: [],
//                         product: ""
//                     });
//                 }
//                 }
//                 onSubmit={handleSubmit}
//             >
//                 {/* Image Upload */}
//                 <div className="p-4 space-y-2">
//                     <label className="block text-sm font-medium text-gray-700"> Image</label>
//                     <input
//                         type="file"
//                         name="image"
//                         onChange={handleImage}
//                         accept="image/*"
//                         className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                     />
//                     {img && (
//                         <img
//                             src={typeof img === 'string' ? img : URL.createObjectURL(img)}
//                             alt="Preview"
//                             className="w-32 h-32 object-cover mt-2 rounded border"
//                         />
//                     )}
//                 </div>

//                 {/* Form Fields */}
//                 <div className="grid lg:grid-cols-2 gap-8 p-4">

//                     <div className="space-y-2 relative">
//                         <label className="block text-sm font-medium text-gray-700">Product</label>
//                         <input
//                             type="text"
//                             value={search}
//                             onChange={(e) => {
//                                 setSearch(e.target.value);
//                                 setIsSelectOpen(true);
//                             }}
//                             onFocus={() => setIsSelectOpen(true)}
//                             placeholder="Search product"
//                             className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                         />
//                         {isSelectOpen && (
//                             <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-auto">
//                                 {filteredOptions.length > 0 ? (
//                                     filteredOptions.map((item) => (
//                                         <li
//                                             key={item.uid}
//                                             onClick={() => {
//                                                 setSearch(item.equip_name);
//                                                 setFormData(prev => ({
//                                                     ...prev,
//                                                     product: item.uid                 // Set actual UID to send
//                                                 }));
//                                                 setIsSelectOpen(false);
//                                                 // update stock_no or any other field
//                                             }}
//                                             className="px-4 py-2 cursor-pointer hover:bg-[#019c89] hover:text-white text-sm"
//                                         >
//                                             {item.equip_name}
//                                         </li>
//                                     ))
//                                 ) : (
//                                     <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
//                                 )}
//                             </ul>
//                         )}
//                     </div>

//                     {titleName.length > 0 && (
//                         <div className="space-y-2">
//                             <label className="block text-sm font-medium text-gray-700">Add in title</label>
//                             <select
//                                 name="title"
//                                 value={formData.title}
//                                 onChange={handleChange}
//                                 className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                             >
//                                 <option value="">Select a title</option>
//                                 {titleName.map((item, index) => (
//                                     <option key={index} value={item}>
//                                         {item}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}


//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">{titleName.length > 0 ? 'New Title' : 'Title'}</label>
//                         <input
//                             type="text"
//                             name="title"
//                             value={formData.title}
//                             onChange={handleChange}
//                             placeholder="Enter title"
//                             className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                         />
//                     </div>

//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">Stock Number</label>
//                         <input
//                             type="text"
//                             name="stock_no"
//                             value={formData.stock_no}
//                             onChange={handleChange}
//                             placeholder="Enter stock number"
//                             className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                         />
//                     </div>

//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">Key Points</label>
//                         <input
//                             type="text"
//                             name="key_points"
//                             value={formData.key_points}
//                             onChange={handleChange}
//                             placeholder="Enter key points"
//                             className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                         />
//                     </div>

//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">Group Number</label>
//                         <select
//                             name="group_no"
//                             value={formData.group_no}
//                             onChange={handleChange}
//                             className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
//                         >
//                             <option value="" disabled>Select group number</option>
//                             <option value="1">1</option>
//                             <option value="2">2</option>
//                             <option value="3">3</option>

//                         </select>
//                     </div>
//                 </div>
//             </CommonPopupForm>



//         </div>
//     )

// }

// export default Departments
